function _(i,n,e){var t=i(109);e.isValue=function(i){return t.isPlainObject(i)&&"value"in i},e.isField=function(i){return t.isPlainObject(i)&&"field"in i}}
//# sourceMappingURL=vectorization.min.js.map